module.exports = __webpack_public_path__ + "static/media/bg-banner-about.498d3719.jpg";